module.exports = __webpack_public_path__ + "static/img/before.d44569f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/vote/before.png
// module id = zHpX
// module chunks = 1